import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useParams, useNavigate, useSearchParams } from "react-router-dom";
import { Box, IconButton, Typography } from "@mui/material";

import { getServicePageRoute } from "../../../../routers/routeUtils";

import { ServiceTypeEnum } from "../../enum/service.enum";
import { useGetService } from "../../api/queries/useGetService";
import { ServiceDetailsBackIcon } from "../../assets/icons/service-details-icons";

import VideoSection from "./VideoSection";
import VideoEquipments from "./VideoEquipments";
import VideoInstructions from "./VideoInstructions";
import ProgramVideoNavigation from "./ProgramVideoNavigation";

const ProgramVideoDetailsPage = () => {
  const { i18n } = useTranslation("goService", { keyPrefix: "programVideoDetailsPage" });

  const { serviceId, videoId } = useParams();

  const [searchParams] = useSearchParams();
  const activeTab = searchParams.get("tab") || "instructions";
  const { data: service, isLoading: isServiceLoading } = useGetService(Number(serviceId));

  const navigate = useNavigate();
  const handleBack = () => navigate(getServicePageRoute(Number(serviceId), ServiceTypeEnum.Program));
  const canRequestService = service?.canRequest;

  useEffect(() => {
    if (isServiceLoading || !service) return;
    if (canRequestService) return navigate(getServicePageRoute(Number(serviceId), ServiceTypeEnum.Program));
  }, [canRequestService, isServiceLoading, service, serviceId, navigate]);

  if (isServiceLoading || !service) return <></>;

  const video = service.programContents!.find((video) => video.id === Number(videoId));
  const { videoTitle, instructions, equipments } = video!;
  return (
    <Box sx={styles.main}>
      <Typography sx={styles.title}>
        <IconButton size="small" onClick={handleBack}>
          <ServiceDetailsBackIcon />
        </IconButton>
        {videoTitle}
      </Typography>
      <VideoSection media={video!.media} />
      <Box sx={styles.content}>
        <ProgramVideoNavigation />
        {activeTab === "instructions" && <VideoInstructions instructions={instructions} />}
        {activeTab === "equipments" && <VideoEquipments equipments={equipments} />}
      </Box>
    </Box>
  );
};

export default ProgramVideoDetailsPage;

const styles = {
  main: {
    display: "flex",
    flexDirection: "column",
  },
  content: {
    display: "flex",
    flexDirection: "column",
    gap: "20px",
    p: "20px",
    borderRadius: "0 0 8px 8px",
    border: "1px solid #EAECF0",
    background: "var(--White, #FFF)",
  },
  title: {
    display: "flex",
    alignItems: "center",
    gap: "8px",
    color: "var(--black-100, #1C1C1C)",
    fontFamily: "Montserrat",
    fontSize: "20px",
    fontStyle: "normal",
    fontWeight: 800,
    lineHeight: "normal",
    mb: "20px",
  },
};
